skrilla.directive('matchPlaceholders',function() {
    return {
        templateUrl: 'directives/matchPlaceholders/matchPlaceholders.html',
        scope: {
            sport: "=",
            onClick: "="
        },
        controller: function($scope, searchService, cacheService, dateService, queryService){
            $scope.key = $scope.sport + "Placeholders";
            $scope.getDate = dateService.getUTC;
            $scope.beforeDate = new Date();
            $scope.beforeDate.setHours(0, 0, 0, 0);
            $scope.afterDate = new Date($scope.beforeDate);
            $scope.afterDate.setHours($scope.beforeDate.getHours() + 24);

            $scope.placeholders = cacheService.getObjectOrElse($scope.key, []);


            $scope.search = function() {
                searchService.get($scope.sport + "/matches/placeholders" + queryService.getQueryString({firstDate: $scope.beforeDate, lastDate: $scope.afterDate})).then(function (response) {
                    $scope.placeholders = response.data;
                    cacheService.registerObject($scope.key, $scope.placeholders);
                });
            }
        }
    };
});
